import React from 'react';
import SectorPage from '../SectorPage/SectorPage';

const ESN = () => {
  const sectorData = {
    title: "ESN",
    subtitle: "Accélérez votre prospection B2B",
    intro: "Dans les ESN (entreprises de services du numérique), la complexité des projets IT et la tension sur les compétences obligent à une prospection technique mais compréhensible. Positionner ses expertises (DevOps, cybersécurité, cloud), proposer des audits d'infrastructure ou des offres de mission clé-en-main permet de capter l'intérêt des décideurs techniques.",
    name: "ESN",
    titleContext: "aux ESN",
    responseContext: "des ESN",
    expertContext: "des ESN"
  };

  return <SectorPage sector={sectorData} />;
};

export default ESN; 